import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PerFormPrimengModule } from '@lbmx/per-form-primeng';
import { UtilsModule } from '@lbmx/phoenix-lib-utils';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule, ProgressSpinnerModule } from 'primeng-lts';
import { EditOptionContainerComponent } from './edit-option-container.component';
import { EditOptionComponent } from './edit-option.component';

@NgModule({
  declarations: [EditOptionComponent, EditOptionContainerComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    PerFormPrimengModule,
    ProgressSpinnerModule,
    ButtonModule,
    UtilsModule,
  ],
  exports: [EditOptionContainerComponent],
})
export class EditOptionModule {}
